import FollowedLeadsLoader from "../followed-leads-loader/FollowedLeadsLoader";

const FollowedLeads = () => {

  
  return (
    <FollowedLeadsLoader
      title={"Briefs à traiter"}
      showMenu={true}
      limit={null}
      paginateResults={true} 
      height={'80%'}
      />
  );

}

export default FollowedLeads;
